import * as models from "./api/models";

export default function isLookupAppKey(value: string): value is models.LookupAppKeys {
    return !!Object.values(models.LookupAppKeys).find((key) => key === value);
}
